// extracted by mini-css-extract-plugin
export default {"products":"Bu-z","card":"Cu-z","oosMessaging":"Du-z"};